import Markdown from 'react-markdown'

import { type SequenceStep, SequenceStepType } from '@/models/sequence'

const CARD = 'border-ink-200 bg-surface mt-2.5 rounded-sm border p-3.5'

/** What an email or SMS step sends, as the rep wrote it (variables still unfilled). */
export function SequenceStepContent({ step }: { step: SequenceStep }) {
  if (step.stepType === SequenceStepType.SEND_EMAIL) {
    return (
      <div className={CARD}>
        <p className="text-sm font-semibold">{step.config.subject || '(no subject)'}</p>
        {step.config.body ? (
          <div className="prose prose-sm prose-p:my-1 mt-1 max-w-none">
            <Markdown>{step.config.body}</Markdown>
          </div>
        ) : (
          <p className="text-ink-500 mt-1 text-sm">(no message)</p>
        )}
      </div>
    )
  }
  if (step.stepType === SequenceStepType.SEND_SMS) {
    return (
      <p className={`${CARD} text-sm whitespace-pre-wrap`}>{step.config.body?.trim() || '(no message)'}</p>
    )
  }
  return null
}
